import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';

export default function Parallax({
  children,
  className,
  style,
  yRange = [-24, 24],
  offset = ['start end', 'end start'],
  mode = 'target',
  scrollRange = [0, 700],
}) {
  const reducedMotion = usePrefersReducedMotion();
  const ref = useRef(null);

  const { scrollY } = useScroll();
  const { scrollYProgress } = useScroll({ target: ref, offset });

  const yFromWindow = useTransform(scrollY, scrollRange, yRange);
  const yFromTarget = useTransform(scrollYProgress, [0, 1], yRange);

  const y = mode === 'window' ? yFromWindow : yFromTarget;

  if (reducedMotion) {
    return (
      <div ref={ref} className={className} style={style}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      className={className}
      style={{ ...style, y, willChange: 'transform' }}
    >
      {children}
    </motion.div>
  );
}

